import request from '@/helpers/customAxios'
import axios from 'axios'
import { IPageNation } from './common'
import { UNZIP_COMPRESS_STATUS_CODE } from '@/constant'

export enum SameFileType {
    ERROR = 0, // unknown error
    NOT_SAME = 1,
    SAME_NAME = 2, // 仅名字一样
    SAME_MD5 = 3, // md5值和名字都一样
}
export async function getFileList(params: IGetFileList): Promise<IFileRes> {
    return request.get('/api/getFileList', { params: params })
}
// export async function getFileListByName(
//   params: IGetFileList
// ): Promise<IFileRes> {
//   return request.get("/api/getFileListByName", { params: params });
// }
export async function getFileListByNameAndTime(params: IGetFileList): Promise<IFileRes> {
    return request.get('/api/getFileListByNameAndTime', { params: params })
}

export async function getFilesDetail(
    ids: string[]
): Promise<{
    code: number
    data: IFileItem[]
    desc: string
}> {
    return request.post('/api/getFilesDetail', { ids })
}

export async function gitDirList(params: IGetDirList): Promise<IFileRes> {
    return request.get('/api/file/list/dir', { params: params })
}
export async function multiMove(params: IMultiList): Promise<IFileRes> {
    return request.post('/api/file/move', params)
}
export async function multiCopy(params: IMultiList): Promise<IFileRes> {
    return request.post('/api/file/copy', params)
}
export async function getDuplicateData(params: ICheckData): Promise<IFileRes> {
    return request.post('/api/file/list/names', params)
}

export async function getRecycleDir(
    params: RecycleList
): Promise<{
    code: number
    data: RecycleData
    desc: string
}> {
    return request.get('/api/recycleDir', { params: params })
}
export interface RecycleData {
    pageInfo: RecyclePageInfo
    powers: number[]
}
export interface RecycleFileItem extends Partial<IFileItem> {
    deleteTime?: string
    location?: string
    updateUser?: string
    userId?: string
}
export interface RecyclePageInfo {
    endRow: number
    hasNextPage: boolean
    hasPreviousPage: boolean
    isFirstPage: boolean
    isLastPage: boolean
    list: RecycleFileItem[]
    navigateFirstPage: number
    navigateLastPage: number
    navigatePages: number
    navigatepageNums: number[]
    nextPage: number
    pageNum: number
    pageSize: number
    pages: number
    prePage: number
    size: number
    startRow: number
    total: number
}
export interface RecycleList {
    name?: string
    startTime?: string
    endTime?: string
    current: number
    sortNum?: number
    size: number
    userId?: string
}
export interface ICheckData {
    names: string[]
    dirId: string
    userId: string
    file: boolean
}
export interface IMultiList {
    ids: string[]
    target: string
    userId: string
}
export interface IGetDirList {
    dirId: string
}
export interface IGetFileList extends IPageNation {
    id?: string
    dirId?: string
    sortNames?: string
    sortTrend?: number
    name?: string
    start?: string | null
    end?: string | null
}
export enum FilePermission { // 文件权限
    PREVIEW = 0,
    UPLOAD = 1,
    DOWNLOAD = 2,
    DELETE = 3,
    UNZIP = 4,
    MKDIR = 5,
}
/**
 *  PREVIEW(0, "预览"),
    UPLOAD(1, "上传"),
    DOWNLOAD(2, "下载");
 */
export interface IFileRes {
    code: number
    data: IFileItem[] | string
    desc: string
    total: number
    ancestors: IFileItem[]
    powers: number[]
}
export interface IFileItem {
    id: string
    name: string
    createTime: string
    size: string
    createUser: string
    isFile: boolean
    parentId?: string
    identifier?: string // MD5值
    powers?: number[] // 权限码
    type?: string // 文件类型
    chunkNum?: number
    createUserName?: string
    leaf?: boolean
    isManager?: boolean
    level?: number
}
export interface IMkdir {
    parentId: string
    name: string
}

export async function mkdir(
    params: IMkdir
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.post('/api/mkdir', params)
}

export async function deleteFileOrDir(
    id: string
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.post('/api/deleteFileOrDir', { id })
}
export async function batchDeleteFileOrDir(
    ids: string[]
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.post('/api/batchDeleteFileOrDir', { ids })
}

export interface ISaveUploadFile {
    fileName: string
    identifier: string
    chunkNum: number
    size: number
    dirId: string
    userId?: string
}
export async function saveUploadFile(
    params: ISaveUploadFile
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.post('/api/saveUploadFile', params)
}

export async function downloadFileById(
    id: string
): Promise<{
    fileName: string
    data: Blob
}> {
    const res = await axios.get('/api/downloadFile', {
        params: { id },
        responseType: 'blob',
        // onDownloadProgress(a) {
        //   if (a.lengthComputable) {
        //     let percent = ((a.loaded * 100) / a.total).toFixed(2);
        //     console.log(percent);
        //   }
        // }
    })
    const str = res.headers['content-disposition']
    const reg = /fileName=(.*)/
    const tmpName = reg.exec(str)![1] || ''
    const fileName = decodeURIComponent(tmpName)
    return {
        data: res.data,
        fileName: fileName,
    }
}
export async function getPermissionList(
    dirId: string
): Promise<{
    code: number
    data: any
    desc: string
}> {
    return request.get('/api/getPermissionList', { params: { dirId } })
}
export interface ISetPermissions {
    dirId: string
    users: string[]
    permissions: number[]
}
export async function setPermissions(
    params: ISetPermissions
): Promise<{
    code: number
    data: any
    desc: string
}> {
    return request.post('/api/setPermissions', params)
}
export async function deletePermissions(
    params: ISetPermissions
): Promise<{
    code: number
    data: any
    desc: string
}> {
    return request.post('/api/deletePermissions', params)
}

export async function unzip(
    id: string
): Promise<{
    code: number
    data: any
    desc: string
}> {
    return request.get('/api/unzip', { params: { id } })
}
export async function compress(
    id: string
): Promise<{
    code: number
    data: any
    desc: string
}> {
    return request.post('/api/compress', { id })
}

export async function batchCompress(params: {
    ids: string[]
    name: string
}): Promise<{
    code: number
    data: any
    desc: string
}> {
    return request.post('/api/batchCompress', params)
}

export interface CompressListItem {
    batches: IFileItem[]
    createTime: string
    createUser: string
    error: string
    file: IFileItem
    id: string
    name: string
    status: UNZIP_COMPRESS_STATUS_CODE
    percent: string
    size: number
}
export interface FileSystemBloodDirsDTO {
    children: FileSystemBloodDirsDTO[]
    id: string
    name: string
    parentId: string
}
export async function getCompressList(): Promise<{
    code: number
    data: CompressListItem[]
    desc: string
}> {
    return request.get('/api/getCompressList')
}
export async function getRelationDirs(
    limitId
): Promise<{
    code: number
    data: FileSystemBloodDirsDTO
    desc: string
}> {
    return request.get('/api/relationDirs', { params: { limitId } })
}
export async function reduceRecycle(params: {
    ids: string[]
}): Promise<{
    code: number
    data: any
    desc: string
}> {
    return request.post('/api/reduceRecycle', params)
}

export interface UnzipListItem {
    createTime: string
    createUser: string
    error: string
    file: IFileItem
    id: string
    percent: string
    status: UNZIP_COMPRESS_STATUS_CODE
    name?: string
}
export async function getUnzipList(): Promise<{
    code: number
    data: UnzipListItem[]
    desc: string
}> {
    return request.get('/api/getUnzipList')
}

export async function unzipOrCompressTaskDelete(
    taskId: string
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.get('/api/unzipOrCompressTaskDelete', { params: { taskId } })
}
export async function unzipOrCompressTaskRetry(
    taskId: string
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.get('/api/unzipOrCompressTaskRetry', { params: { taskId } })
}

export interface IRename {
    id: string
    newFileName: string
}
export async function rename(
    params: IRename
): Promise<{
    code: number
    data: any
    desc: string
}> {
    return request.post('/api/rename', params)
}

export interface GetTaskList {
    types: '0' | '1' //  0.上传 1.下载
    status: '0' | '1' | '2' | '3' // 0.执行中, 1.暂停, 2.取消, 3.完成
    search?: string
    startTime?: string
    endTime?: string
}
export interface GetTaskItem {
    chunkSerialNums: string[]
    chunkSize: number
    completeTime: string
    createTime: string
    id: string
    name: string
    path: string
    status: number
    totalSize: number
    type: number
    updateTime: string
    uploadChunkSize: number
    userId: string
}

export async function getTaskList(
    params: GetTaskList
): Promise<{
    code: number
    data: GetTaskItem[]
    desc: string
}> {
    return request.get('/api/getTaskList', { params: params })
}

export interface ShareFileInfo {
    createTime: string
    createUserId: string
    expireTime: string
    file: {
        name: string
    }
    fileId: string
    fileSize: number
    id: string
    isFile: boolean
    shareUserList: string[]
    surplusMillis: number
    type: number
    updateTime: string
    url: string
}
export async function getShareFileInfo(params: {
    id: string
}): Promise<{
    code: number
    data: ShareFileInfo
    desc: string
}> {
    return request.get('/api/getShareFileInfo')
}
export async function getUserNotExpiredList(): Promise<{
    code: number
    data: ShareFileInfo[]
    desc: string
}> {
    return request.get('/api/getUserNotExpiredList')
}

export async function copyMoveFile(param: {
    id: string
    target: string
    type: 'move' | 'copy'
}): Promise<{
    code: number
    data: string
    desc: string
}> {
    const { id, target, type } = param
    let res
    if (!id || !target) {
        return {
            code: 1,
            data: '',
            desc: '参数错误',
        }
    }
    if (type === 'move' && id === target) {
        return {
            code: 1,
            data: '',
            desc: '移动源目文件不可相同',
        }
    }

    try {
        res = await request.get(`/api/${type}`, { params: { id, target } })
    } catch (e) {
        res = {
            code: 1,
            data: '',
            desc: '网络错误',
        }
    }
    return res
}

export enum DragState {
    'DEFAULT' = 0,
    'MOVE' = 1,
    'UPLOAD' = 2,
}

export async function getZipDetail(
    id: string
): Promise<{
    code: number
    data: ZipDetail
    desc: string
}> {
    return request.get('/api/getZipDetail', { params: { id } })
}

export interface ZipDetail {
    dirNum: number
    fileNum: number
    totalOriginal?: number
    typeAndNum: { [key: string]: any }
}

export async function getDirStats(
    dirId: string
): Promise<{
    code: number
    data: DirStats
    desc: string
}> {
    return request.get('/api/dirStats', { params: { dirId } })
}
export interface DirStats extends ZipDetail {
    totalSize: number
}

/** 获取文件夹权限拥有者 */
export interface DirPowerParams {
    dirId: string
    current?: number
    size?: number
}
export interface DirPower {
    createTime: string
    createUser: string
    fileId: string
    id: number
    powers: number[]
    topId: string
    updateTime: string
    updateUser: string
    userId: string
    userName: string
}
export async function dirPower(
    params: DirPowerParams
): Promise<{
    code: number
    data: DirPower[]
    desc: string
}> {
    return request.get('/api/dirPower', { params })
}

/**授权 */
export interface EditPowerParams {
    dirId: string
    powers: number[]
    userIds: string[]
}
export async function grantPower(
    params: EditPowerParams
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.post('/api/grantPower', params)
}

export async function updatePower(
    params: EditPowerParams
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.post('/api/updatePower', params)
}

/** 审批列表 */
export interface ListApprovalParams {
    dirName?: string
    nameOrId?: string
}
export interface ListApproval {
    applicant?: string
    applicantId?: string
    code?: string
    createTime?: string
    dirId?: string
    dirName?: string
    fullName?: string
    id?: number
    state?: string
    topId?: string
    updateTime?: string
    updateUserId?: string
    updateUserName?: string
}
export interface ListApprovalData {
    endRow: number
    hasNextPage: boolean
    hasPreviousPage: boolean
    isFirstPage: boolean
    isLastPage: boolean
    list: ListApproval[]
    navigateFirstPage: number
    navigateLastPage: number
    navigatePages: number
    navigatepageNums: number[]
    nextPage: number
    pageNum: number
    pageSize: number
    pages: number
    prePage: number
    size: number
    startRow: number
    total: number
}
export async function listApproval(
    params: ListApprovalParams
): Promise<{
    code: number
    data: ListApprovalData
    desc: string
}> {
    return request.get('/api/listApproval', { params })
}

/** 审批操作 */
export interface OperateApprovalParams {
    id: string
    state: 0 | 1 | 2 // 审批结果状态0（未审批） 1（已通过） 2（已拒绝)
}
export async function operateApproval(
    params: OperateApprovalParams
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.post('/api/operateApproval', params)
}

/** 权限码申请权限 */
export interface ApplicantCmd {
    permissionCodes?: string[]
    powers?: number[]
    userIds?: string[]
}
export interface ApplicantParams {
    cmd: ApplicantCmd
}
export async function applicant(
    params: ApplicantParams
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.post('/api/applicant', params)
}

export interface UserData {
    manageTopIds: string[]
    powerMap: {
        [key: string]: number[]
    }
    relatedTopIds: string[]
    roles: string[]
    userId: string
}
/** 验证记录用户 */

export async function loginInfo(): Promise<{
    code: number
    data: UserData
    desc: string
}> {
    return request.get('/api/loginInfo')
}
export interface ApplicantList {
    fileName: string
    size: number
    current: number
}
/** 权限列表 */
export async function applicantList(
    params: ApplicantList
): Promise<{
    code: number
    data: ListApprovalData
    desc: string
}> {
    return request.get('/api/applicantList', { params })
}

/** 获取权限码 */
export async function getCode(
    fileId: string
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.get('/api/getCode', { params: { fileId } })
}

/** 查询开发者账账号 */
export interface UserInfo {
    account: string
    createTime: string
    createUser: string
    dirName: string
    id: number
    password: string
    rootId: string
    updateTime: string
    updateUserId: string
    updateUserName: string
}
export async function getDevAccount(
    rootId: string
): Promise<{
    code: number
    data: UserInfo
    desc: string
}> {
    return request.get('/api/getDevAccount', { params: { rootId } })
}
export async function fileDownloadUrl(
    fileId: string
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.get('/api/fileDownloadUrl', { params: { fileId } })
}
export async function cancelCompressOrUnzip(
    taskId: string
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.get('/api/cancelCompressOrUnzip', { params: { taskId } })
}

export async function checkBeforeDownload(
    fileId: string,
    shareIdentify= ''
): Promise<{
    code: number
    data: string
    desc: string
}> {
    return request.get('/api/checkBeforeDownload', { params: { fileId, shareIdentify} })
}
